export const MODIFY_UTILITIES_INFO = 'MODIFY_UTILITIES_INFO';

export function modifyUtilitiesInfo(utilitiesInfo){
    return{
        type: MODIFY_UTILITIES_INFO,
        mainState: {
            utilitiesInfo: utilitiesInfo
        }
    }
}